import { Box, Grid, Theme } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import MuiPageWrapper from '@/@mui/MuiPageWrapper';

interface BasePublicMuiPageProps extends PropsWithChildren {
  themeOverrides?: (theme: Theme) => Theme;
}

const BasePublicMuiPage: React.FC<BasePublicMuiPageProps> = ({ children, themeOverrides }) => (
  <MuiPageWrapper themeOverrides={themeOverrides}>
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        overflowY: 'visible',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          maxWidth: 1280,
          width: '100%',
          p: 1.5,
          margin: '0 auto',
          backgroundImage: 'url(/assets/images/background-pattern.png)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '1920px 1440px',
          backgroundPosition: 'top center',
          em: {
            fontWeight: 500,
            fontStyle: 'normal',
          },
        }}
      >
        <Grid container spacing={2}>
          {children}
        </Grid>
      </Box>
    </Box>
  </MuiPageWrapper>
);

export default BasePublicMuiPage;
